var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridiconsCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:cross-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5413 3.47129C10.7788 0.708789 6.24551 0.708789 3.48301 3.47129C0.720508 6.23379 0.720508 10.7671 3.48301 13.5296C6.24551 16.2921 10.708 16.2921 13.4705 13.5296C16.233 10.7671 16.3038 6.23379 13.5413 3.47129ZM10.4955 11.4755L8.51218 9.49212L6.52884 11.4755L5.53718 10.4838L7.52051 8.50046L5.53718 6.51712L6.52884 5.52546L8.51218 7.50879L10.4955 5.52546L11.4872 6.51712L9.50384 8.50046L11.4872 10.4838L10.4955 11.4755Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsCrossCircle);
export default __webpack_public_path__ + "static/media/gridicons_cross-circle.85511b845d9cc1d5d14bda80940ac87b.svg";
export { ForwardRef as ReactComponent };